import { useEffect } from 'react';
import { getIsListOpen, getDetailsEl, getSummaryEl } from '../utils';
const useToggleOffOnClick = ({ name, hasValueChanged, isOutsideClick, isEnterPress, setIsEnterPress, isEscOrTabPress, setIsEscOrTabPress, setOff }) => {
    const shouldToggleOffOnClick = 
    // because keyboard navigation also triggers clicks (we want to ignore here)
    (!isEnterPress && hasValueChanged) || isOutsideClick || isEscOrTabPress;
    // should always run, so no dependency array (and 2 useEffects)
    useEffect(() => {
        const detailsEl = getDetailsEl(name);
        const summaryEl = getSummaryEl(name);
        if (shouldToggleOffOnClick && detailsEl && summaryEl && getIsListOpen(name)) {
            detailsEl.removeAttribute('open');
            summaryEl.focus();
        }
    });
    useEffect(() => {
        if (isEscOrTabPress) {
            setOff();
            setIsEscOrTabPress(false);
        }
        if (isOutsideClick) {
            setOff();
            setIsEnterPress(false);
        }
    }, [isOutsideClick, setOff, setIsEnterPress, isEscOrTabPress, setIsEscOrTabPress]);
};
export default useToggleOffOnClick;
//# sourceMappingURL=useToggleOffOnClick.js.map